import './assets/fonts/font.css';
import './styles/root.scss';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { Provider } from 'react-redux';
import { reduxStore } from './store/store';
import { Amplify } from 'aws-amplify';
import amplifyConfig from "./amplifyconfiguration.json";

Amplify.configure(amplifyConfig);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <Provider store={reduxStore}>
    <App />
  </Provider>
);
